import { Action, Subject } from "../enums/permissions";

const buildAdminAbility = () =>
  Object.values(Subject).flatMap((subject) =>
    Object.values(Action).map((action) => ({
      action,
      subject,
    }))
  );

const storedAbility = localStorage.getItem("ability");
const storedRole = localStorage.getItem("role");
const sessionUserData = sessionStorage.getItem("userData");

let parsedSessionUser: any = null;
if (sessionUserData) {
  try {
    parsedSessionUser = JSON.parse(sessionUserData);
  } catch (error) {
    parsedSessionUser = null;
  }
}

let parsedAbility: Array<{ action: string; subject: string }> = [];

if (storedAbility) {
  try {
    parsedAbility = JSON.parse(storedAbility);
  } catch (error) {
    parsedAbility = [];
  }
}

const isAdminUser =
  storedRole === "Admin" ||
  parsedSessionUser?.roles?.name === "Admin" ||
  parsedSessionUser?.email === "admin@gmail.com";

if (isAdminUser && parsedAbility.length === 0) {
  parsedAbility = buildAdminAbility();
  localStorage.setItem("ability", JSON.stringify(parsedAbility));
  localStorage.setItem(
    "permissions",
    JSON.stringify(parsedAbility.map(({ subject, action }) => `${subject}_${action}`))
  );
}

export const initialAbility = parsedAbility.length
  ? parsedAbility
  : [
      {
        action: "",
        subject: "",
      },
    ];

export const _ = undefined;
